// Language data organized by region
// Keys MUST match exactly with keys in data/languages.json
export const languageData: Record<string, string[]> = {
  Europe: [
    "German",
    "English (United Kingdom)",
    "Spanish (Spain)",
    "French",
    "Italian",
    "Dutch",
    "Polish",
    "Russian",
    "Turkish",
    "Portuguese (Portugal)",
    "Greek",
    "Swedish",
    "Norwegian",
    "Danish",
    "Finnish",
    "Ukrainian",
    "Bulgarian",
    "Croatian",
    "Czech",
    "Hungarian",
    "Romanian",
    "Serbian",
    "Slovak",
    "Slovenian",
    "Catalan",
    "Galician",
    "Basque",
    "Estonian",
    "Latvian",
    "Lithuanian",
    "Icelandic",
    "Maltese",
    "Albanian",
    "Macedonian",
  ],
  Asia: [
    "Mandarin Chinese",
    "Cantonese (Hong Kong)",
    "Japanese",
    "Korean",
    "Hindi",
    "English (India)",
    "Vietnamese",
    "Thai",
    "Indonesian",
    "Filipino",
    "Malay",
    "Bengali",
    "Gujarati",
    "Kannada",
    "Malayalam",
    "Marathi",
    "Tamil",
    "Telugu",
    "Urdu",
    "Pashto",
    "Kurdish",
    "Nepali",
    "Sinhala",
    "Burmese",
    "Khmer",
    "Lao",
    "Kazakh",
    "Mongolian",
    "Uzbek",
    "Turkmen",
    "Armenian",
    "Georgian",
  ],
  Americas: [
    "English (United States)",
    "Latin American Spanish",
    "Portuguese (Brazil)",
    "French (Canada)",
  ],
  Oceania: ["English (Australia)"],
  "Africa & Middle East": [
    "Arabic (MSA)",
    "Arabic (Egypt)",
    "Arabic (Gulf)",
    "Arabic (Lebanon)",
    "Hebrew",
    "Farsi",
    "Swahili",
    "Afrikaans",
    "Amharic",
  ],
};
